<div class="order-product-list">
	<div class="products">
		@for (item of itemData$().items; track item.uuid) {
			<div class="product" data-cy="orderProduct">
				<!-- TODO: Refactor using plain CSS Grid properly. -->
				<div class="product-grid">
					<g-product-image
						[images]="itemData$().productImages.get(item.uuid)!"
						key="fitIn_80x80"
						isZoomable
						[altText]="item.work_title || (item.product?.locale?.product_name | getText)"
						[proofImageDetails]="itemData$().proofImageDetails.get(item.uuid)"
						class="product-image"
					/>

					<div class="product-details">
						<a class="product-link" [title]="item.work_title">
							{{ item.work_title }}
						</a>
					</div>
					<div class="product-quantity">
						{{ item | getProductQuantity }}&nbsp;
						<span>{{ item | getQuantityUnit }}</span>
					</div>
					@if (showPrices$()) {
						<div class="product-price"> {{ item?.price?.price_with_tax | number: '1.2-2' }} € </div>
					}

					@if (buttonVisibilityData$().isButtonColumnVisible.get(item.uuid)) {
						<div class="product-button hide-in-print">
							@if (buttonVisibilityData$().isDownloadButtonVisible.get(item.uuid)) {
								<button
									class="btn btn-small btn-secondary"
									(click)="downloadProductAsset(item)"
									i18n="@@OrderProductDownloadButton"
									>Download</button
								>
							}
							@if (buttonVisibilityData$().isCopyButtonVisible.get(item.uuid)) {
								<button
									class="btn btn-small btn-primary"
									[disabled]="
										!isExistingProduct(item) ||
										(item.product?.type === 'stock' &&
											!!item.product?.id &&
											stockLevels.get(item.product!.id!) === 0)
									"
									(click)="copyToBasket(item)"
									data-cy="copyToBasketButton"
									i18n="@@OrderProductCopyToBasketButton"
									>Copy to basket</button
								>
							}
						</div>
					}
				</div>
				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					isOrderStatusReady &&
					!isExistingProduct(item)
				) {
					<div class="product-notification hide-in-print">
						<span i18n="@@OrderProductListNotificationProductDoesNotExist"
							>Product has been removed from store and cannot be reordered.</span
						>
					</div>
				}
				@if (showPrintfileError(item)) {
					<span class="error" i18n="@@ProductPrintfileExpired"
						>The printfile has expired. Remove this item and re-upload the printfile.</span
					>
				}
				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					!!item.product?.id &&
					stockLevels.get(item.product!.id!)! > 0 &&
					(item | getProductQuantity) > stockLevels.get(item.product!.id!)!
				) {
					<div class="product-notification hide-in-print">
						<span i18n="@@OrderProductListNotificationNotEnoughStock"
							>Not enough products in stock.</span
						>
					</div>
				}
				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					item.product &&
					item.product.id &&
					stockLevels.get(item.product.id) === 0
				) {
					<div class="product-notification hide-in-print">
						<span i18n="@@OrderProductListNotificationOutOfStock">Product is out of stock.</span>
					</div>
				}
			</div>
		}
	</div>
</div>
